// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "com.daffione",
    name: "DaffiOne",
    homepage: "https://www.daffione.com/",
    image_id: "1e87bcb9-452c-4ad7-471c-130ae0115000",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.me.daffione",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "DaffiOne:// wc://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map